var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"no-product"},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"8","offset-lg":"2","xl":"8","offset-xl":"2"}},[_c('h3',[_vm._v("The Product that you are looking for is no longer available")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }